/**
 * API - User
 * https://bitbucket.org/interlective/bridgealliance_react_frontend
 */

async function registration(regobj) {
  return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/request-reg`, {
    timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(regobj)
  });
}

async function requestLogin(loginobj) {
  return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/requestLink`, {
    timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(loginobj)
  });
}

async function validateToken(token) {
  return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/jwt-auth/v1/token/validate`, {
    timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  });

}

async function getUser(token) {
  return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wp/v2/users/me`, {
    timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  });

}

async function loginViaLink(formdata) {
  return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/token`, {
    timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(formdata)
  });
}

//*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
async function setUserActivitylog(formdata) {
  return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/activitylog`, {
    timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(formdata)
  });
}
/*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/


export default {
  requestLogin,
  getUser,
  validateToken,
  loginViaLink,
  registration,
  setUserActivitylog  /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
};